import {
  INDONESIAN_CURRENCY_CODE,
  LOCALE_SETTINGS,
  ROUNDED_CURRENCIES,
} from '../config/constants/geo';
import { isEmpty, isString } from './index';

export const abbreviateNumber = n => {
  if (n < 1e3) return Number.isInteger(n) ? n : n.toFixed(2);
  if (n >= 1e3 && n < 1e6) return `${+(n / 1e3).toFixed(1)}K`;
  if (n >= 1e6 && n < 1e9) return `${+(n / 1e6).toFixed(1)}M`;
  if (n >= 1e9 && n < 1e12) return `${+(n / 1e9).toFixed(1)}B`;
  if (n >= 1e12) return `${+(n / 1e12).toFixed(1)}T`;
  return null;
};

export const getCurrency = (currency = {}) =>
  !isEmpty(currency) && currency.symbol ? currency.symbol : '$';

export const getDisplayPrice = (
  price,
  thousandSeparator = ',',
  decimalSeparator = '.',
) => {
  const [integerPart, decimalPart] = price.toString().split('.');
  const thousandSeparatedIntPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    thousandSeparator,
  );
  return `${thousandSeparatedIntPart}${decimalSeparator}${decimalPart}`;
};

export const centToMoney = (cent, fractionDigits = 2) => {
  if (!cent) {
    return fractionDigits === 0 ? '0' : (0).toFixed(fractionDigits);
  }
  return (cent / 100).toFixed(fractionDigits);
};

export const readablePrice = (
  cent = 0,
  currency = {},
  fractionDigits = 2,
  ignoreRoundOff = false,
) => {
  const locale = LOCALE_SETTINGS[currency?.code];
  const symbol = getCurrency(currency);
  if (!locale) return `${symbol}${cent / 100}`;

  let displayPrice = '';

  if (!ignoreRoundOff && ROUNDED_CURRENCIES.includes(currency?.code)) {
    const money = Math.round(cent / 100);

    const currencyFractionDigits = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency?.code,
    }).resolvedOptions().maximumFractionDigits;

    displayPrice = money.toLocaleString(locale, {
      maximumFractionDigits: currencyFractionDigits,
    });
  } else {
    const money = centToMoney(cent, fractionDigits);
    const [thSeparator, decSeparator] = [INDONESIAN_CURRENCY_CODE].includes(
      currency?.code,
    )
      ? ['.', ',']
      : [',', '.'];
    displayPrice = getDisplayPrice(money, thSeparator, decSeparator);
  }

  return `${symbol}${displayPrice}`;
};

export const getReadableRoundOff = (amount = 0, currency) => {
  // Determine the positive or negative sign based on totalCents
  const sign = amount >= 0 ? '+' : '-';

  // Format the currency display value with the sign
  return `${sign}${readablePrice(Math.abs(amount), currency)}`;
};

export const toCent = money => {
  if (!money || Number.isNaN(money)) {
    return 0;
  }
  let value = money;
  if (isString(money)) {
    value = Number(money);
  }
  return Math.round(value * 100 * 1e12) / 1e12;
};
